export function recoveryControls(recovery) {
  const needsCopy = Boolean(
    recovery?.customer_recovery_required || recovery?.saved_cards || recovery?.subscriptions
  )
  const customerReady =
    !needsCopy ||
    (recovery?.copy_validated === true && recovery?.customer_recovery_complete === true)
  const readers = recovery?.readers?.filter((reader) => !reader.recovered) ?? []
  return {
    readers,
    // Presentation only: keep one actionable task visible, without another persisted workflow.
    step:
      recovery?.status === 'active'
        ? 'complete'
        : recovery?.source_disconnected || recovery?.target_disconnected
          ? 'account-access'
          : !recovery?.target_ready
            ? 'account-readiness'
            : (!recovery?.customers_complete && !recovery?.inventory_complete) ||
                recovery?.status !== 'recovery'
              ? 'checking'
              : !customerReady
                ? 'copy'
                : !recovery?.inventory_complete
                  ? 'checking'
                  : readers.length
                    ? 'readers'
                    : 'finishing',
  }
}

export function isStripeUpgradeComplete(migration) {
  return Boolean(
    migration?.activated && (!migration.recovery || migration.recovery.status === 'active')
  )
}
